import { useEffect, useState, useRef } from 'react';

import { CloseOutlined } from '@ant-design/icons';
import useUserStore from '@lcsc-ui/store/user';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { message, Select } from 'antd';
import Link from 'next/link';

import API from '@/apis';
import Image from '@/components/Image';
import { noGoodsDefaultImg } from '@/constants';

export default function CompareDialog({ row, isShowCompareDialog, setIsShowCompareDialog }) {
  const projectConfigVO = useUserStore((state) => state.projectConfigVO);
  const [compareList, setCompareList] = useState(row);
  const compareBtnRef = useRef();

  useEffect(() => {
    setCompareList(row);
  }, [isShowCompareDialog]);

  const handleCancel = () => {
    setIsShowCompareDialog(false);
  };

  const clickCompare = () => {
    if (compareList.length < 2) {
      message.error('至少选择两种商品进行对比！');
      return;
    }
    sendAxios({
      method: 'GET',
      baseURL: 'lcscSearchUrl',
      url: API.compareProductCheckV2,
    }).then(({ result }) => {
      if (result?.check_result === 'fail') {
        message.error('至少选择两种商品进行对比！');
      } else {
        const el = compareBtnRef.current;
        const url = Utils.getBtnSpmQueryUrl(`${projectConfigVO.lcscSearchUrl}/compare/product/detail.html`, el);
        window.open(url, '_blank');
      }
    });
  };

  const clickDelCompare = (compareItem) => {
    sendAxios({
      method: 'GET',
      baseURL: 'lcscSearchUrl',
      url: `${API.compareProductRemoveV2}?productId=${compareItem.productId}`,
    }).then(() => {
      selectProductFromCookie();
    });
  };

  const clickDelAllCompare = () => {
    sendAxios({
      method: 'GET',
      baseURL: 'lcscSearchUrl',
      url: API.compareProductRemoveAllV2,
    }).then(() => {
      selectProductFromCookie();
    });
  };

  const selectProductFromCookie = () => {
    sendAxios({
      method: 'GET',
      baseURL: 'lcscSearchUrl',
      url: API.compareProductGetV2,
    }).then(({ result }) => {
      setCompareList(result);
    });
  };

  const changePriceFn = (v, productPriceList) => {
    const priceList = [];
    const theRatio = parseInt(v.convesionRatio);
    productPriceList?.forEach((val) => {
      const spNumber = parseInt(val.startPurchasedNumber);
      const sepPrice = parseFloat(val.productPrice);
      const thePrice = parseFloat(sepPrice);
      const priceItem = {
        label: `${spNumber * theRatio}：￥${thePrice}`,
        value: spNumber,
      };
      priceList.push(priceItem);
    });
    return priceList;
  };

  const defaultItem = (idx) => (
    <>
      <div className="w-[280px] h-[82px] flex">
        <div className="w-[82px] h-[82px] bg-[#f3f3f3] text-center rounded">
          <b className="text-[50px] text-[#ccc] leading-[82px]">{idx + 1}</b>
        </div>
        <p className="ml-[10px] text-[#ccc] text-[14px]">你还可以继续添加</p>
      </div>
    </>
  );

  const productItem = (compareItem) => {
    return (
      <>
        <div className="w-[280px] h-[82px] flex justify-start text-[12px] leading-[24px]">
          <Image
            src={compareItem.breviaryImageUrl || noGoodsDefaultImg}
            className="rounded"
            alt={compareItem.title}
            height={82}
            width={82}
          />
          <div className="ml-[10px] w-[185px] pr-[20px]">
            <div className="flex justify-between lc-text-hidden">
              <Link rel="stylesheet" href={`/${compareItem.productId}.html`}>
                <p className="lc-text-hidden hover:text-[#0093e6] w-[130px]">{compareItem.productName}</p>
              </Link>
              <button className="text-[#0093e6]" onClick={() => clickDelCompare(compareItem)}>
                删除
              </button>
            </div>
            <p className="lc-text-hidden">{compareItem.productModel}</p>
            {compareItem?.isShowPrice === false ? (
              <>需询价</>
            ) : (
              <Select
                className="mt-[8px] w-[160px]"
                size="small"
                getPopupContainer={() => document.getElementById('compareArea')}
                defaultValue={
                  compareItem.productPriceList[compareItem.productPriceList.length - 1]?.startPurchasedNumber
                }
                width={178}
                options={changePriceFn(compareItem, compareItem.productPriceList)}
              />
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {isShowCompareDialog && (
        <div
          id="compareArea"
          title="对比栏"
          className="w-[1000px] fixed top-[75%] bg-[#fff] border-[1px] border-[#cccc] border-solid z-[99] p-[20px] rounded-[20px]"
          data-spm="xcp"
        >
          <header className="flex justify-between items-baseline">
            <h1 className="text-[16px] text-[#000] bold pb-[10px]">对比栏</h1>
            <CloseOutlined className="cursor-pointer" onClick={handleCancel} />
          </header>

          <ul className="flex">
            {compareList?.map((compareItem, idx) => {
              return (
                <li key={idx} className="mt-[10px]">
                  {compareItem?.productId === '-1' ? defaultItem(idx) : productItem(compareItem, idx)}
                </li>
              );
            })}
            <li className="w-[100px] p-[10px] border-l-[1px] border-[#ccc] border-solid block text-center">
              <button
                ref={compareBtnRef}
                className="bg-[#0093E6] rounded text-[#fff] w-[60px] h-[25px]"
                onClick={clickCompare}
                data-spm="cmp"
              >
                对比
              </button>
              <button className="mt-[10px] text-[#0093e6]" onClick={clickDelAllCompare}>
                清空对比栏
              </button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}
